import { ChangeEvent } from "./ChangeEvent";
import { DomEvent } from "./DomEvent";
import { EventListener } from "./Event";
import { SplitterOrientation } from "../components/splitter/SplitterProps";

export interface SplitterChangeListener extends EventListener {
    (event: SplitterChangeEvent): void;
}

export class SplitterChangeEvent extends ChangeEvent {
    private _oldOrientation: SplitterOrientation;
    private _newOrientation: SplitterOrientation;

    constructor(component: any, newPosition: number|string, newOrientation: SplitterOrientation,
        oldPosition: number|string, oldOrientation: SplitterOrientation, domEvent?: DomEvent) {
        super(component, oldPosition, newPosition, domEvent);
        this._oldOrientation = oldOrientation;
        this._newOrientation = newOrientation;
    }

    public get oldPosition(): number|string {
        return this.oldValue;
    }

    public get newPosition(): number|string {
        return this.newValue;
    }

    public get oldOrientation(): SplitterOrientation {
        return this._oldOrientation;
    }

    public get newOrientation(): SplitterOrientation {
        return this._newOrientation;
    }
}
